import React from "react";

function WebcamOnIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16">
  <g id="Icon_ionic-ios-videocam" data-name="Icon ionic-ios-videocam" transform="translate(-2.25 -9)">
    <path id="Path_81594" data-name="Path 81594" d="M30.9,10.8a1.068,1.068,0,0,0-.581.169l-5.406,3.413a.535.535,0,0,0-.25.45v4.75a.535.535,0,0,0,.25.45l5.406,3.413a1.123,1.123,0,0,0,.581.169h1.3a.532.532,0,0,0,.538-.531V11.331A.536.536,0,0,0,32.2,10.8Z" transform="translate(-2.491 -0.2)" fill="#f45e29"/>
    <path id="Path_81595" data-name="Path 81595" d="M17.344,25H5.469A3.229,3.229,0,0,1,2.25,21.788V12.212A3.224,3.224,0,0,1,5.462,9H17.338a3.224,3.224,0,0,1,3.213,3.212v9.569A3.216,3.216,0,0,1,17.344,25Z" fill="#f45e29"/>
  </g>
</svg>

  );
}

export default WebcamOnIcon;
